import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-admin-changepassword',
  templateUrl: './admin-changepassword.component.html',
  styleUrls: ['./admin-changepassword.component.scss']
})
export class AdminChangepasswordComponent implements OnInit {
  passwordForm: any
  id: any = this.data?.id;
  showPassword: any = true;
  showPassword2: any = true
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<AdminChangepasswordComponent>,
    private service: ApiService,
    private toastr: ToastrService,

  ) {

  }
  ngOnInit() {
    this.passwordForm = new FormGroup({
      password: new FormControl('', Validators.required),
      confirmpassword: new FormControl('', Validators.required)
    })
  }

  onCancel() {
    this.dialog.close()
  }
  changePassword() {

    let password = this.passwordForm.value.password;
    let confirmpassword = this.passwordForm.value.confirmpassword

    if (this.passwordForm.valid) {
      if (password == confirmpassword) {
        let data = {
          password: this.passwordForm.value.password
        }
        this.service.putRequest(`${ApiUrl.changepassword}${this.id}`, data).subscribe((res: any) => {
          // console.log(res)
          this.toastr.success(res.response.message)
          this.dialog.close()
        }, (err: any) => {
          this.toastr.error(err?.error?.response?.message)
        })

      } else {
        this.toastr.error('Password and confirm password does not match')
      }
    } else {
      this.toastr.error('Please enter password')
    }

  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  togglePasswordVisibility2() {
    this.showPassword2 = !this.showPassword2;
  }

}
